import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { CONTACT } from "@/data/site";
import { SocialLinks } from "./SocialLinks";

const ITEMS = [
  { id: "phone", icon: Phone, label: "Telefon", value: CONTACT.phone, href: CONTACT.phoneHref },
  { id: "email", icon: Mail, label: "E-Mail", value: <>{CONTACT.email.split("@")[0]}@<wbr />{CONTACT.email.split("@")[1]}</>, href: CONTACT.emailHref },
  { id: "whatsapp", icon: MessageCircle, label: "WhatsApp", value: CONTACT.whatsapp ? "Nachricht schreiben" : "Bald verfügbar", href: CONTACT.whatsapp ? `https://wa.me/${CONTACT.whatsapp}` : null },
  { id: "location", icon: MapPin, label: "Einsatzgebiet", value: "Bottrop & Umgebung" },
];

export const ContactCard = () => (
  <div className="h-full rounded-[28px] bg-[#111511] text-white p-7 sm:p-10 flex flex-col justify-between gap-10 relative overflow-hidden">
    <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#9CC26A]/20 blur-3xl pointer-events-none" />
    <div className="relative">
      <p className="font-head text-3xl sm:text-4xl font-semibold tracking-tight leading-tight">Lieber direkt sprechen?</p>
      <p className="mt-3 text-[#C9CEC6] leading-relaxed">Rufen Sie an oder schreiben Sie uns – wir melden uns schnellstmöglich zurück.</p>
    </div>
    <div className="relative grid gap-3">
      {ITEMS.map((c) => {
        const Tag = c.href ? "a" : "div";
        return (
          <Tag key={c.id} {...(c.href ? { href: c.href, target: c.id === "whatsapp" ? "_blank" : "_top", rel: "noreferrer" } : {})} data-testid={`contact-${c.id}`}
            className={`group flex items-center gap-4 rounded-2xl border border-white/10 p-4 transition-colors duration-300 ${c.href ? "hover:bg-white hover:text-[#111511]" : "opacity-80"}`}>
            <span className="w-11 h-11 shrink-0 rounded-full bg-[#9CC26A] text-[#111511] flex items-center justify-center"><c.icon className="w-5 h-5" strokeWidth={1.7} /></span>
            <span className="min-w-0">
              <span className="block text-xs uppercase tracking-[0.16em] text-[#A9B0A6] group-hover:text-current">{c.label}</span>
              <span className="block mt-0.5 font-head text-base sm:text-lg font-semibold [overflow-wrap:anywhere]">{c.value}</span>
            </span>
          </Tag>
        );
      })}
    </div>
    <div className="relative">
      <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#A9B0A6]">Folgen Sie uns</p>
      <SocialLinks dark />
    </div>
  </div>
);
